import Swal from "sweetalert2";
import "../index.css";
import { GlobalContext } from "../context/GlobalContext";
import "../App.css";
import Cookies from "js-cookie";
import axios from "axios";
import { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";

function EditForm() {
  const { IdData } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const { setFetchStatus, setCurrentId } = useContext(GlobalContext);

  const [title, settitle] = useState("");
  const [job_description, setjob_description] = useState("");
  const [company_image_url, setcompany_image_url] = useState("");
  const [job_qualification, setjob_qualification] = useState("");
  const [job_type, setjob_type] = useState("");
  const [job_tenure, setjob_tenure] = useState("");
  const [job_status, setjob_status] = useState(0);
  const [company_name, setcompany_name] = useState("");
  const [company_city, setcompany_city] = useState("");
  const [salary_min, setsalary_min] = useState(0);
  const [salary_max, setsalary_max] = useState(0);
  const functionEdit = () => {
    setIsLoading(true);
    axios
      .get(`https://dev-example.sanbercloud.com/api/job-vacancy/${IdData}`)
      .then((result) => {
        let fetchResult = result.data;
        settitle(fetchResult.title);
        setjob_description(fetchResult.job_description);
        setcompany_image_url(fetchResult.company_image_url);
        setjob_qualification(fetchResult.job_qualification);
        setjob_type(fetchResult.job_type);
        setjob_tenure(fetchResult.job_tenure);
        setjob_status(fetchResult.job_status);
        setcompany_name(fetchResult.company_name);
        setcompany_city(fetchResult.company_city);
        setsalary_min(fetchResult.salary_min);
        setsalary_max(fetchResult.salary_max);
        setCurrentId(fetchResult.id);
      })
      .finally(setIsLoading(false));
  };
  useEffect(() => {
    functionEdit();
  }, []);

  const handleSubmit = async () => {
    setIsLoading(true);
    let token = Cookies.get("token");
    try {
      await axios
        .put(
          `https://dev-example.sanbercloud.com/api/job-vacancy/${IdData}`,
          {
            title: title,
            job_description: job_description,
            company_image_url: company_image_url,
            job_qualification: job_qualification,
            job_type: job_type,
            job_tenure: job_tenure,
            job_status: job_status,
            company_name: company_name,
            company_city: company_city,
            salary_min: salary_min,
            salary_max: salary_max,
          },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        .then((res) => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1000,
          });
        })
        .finally(() => {
          setTimeout(() => {
            setIsLoading(false);
            setFetchStatus(true);
            return navigate("/dashboard/list-job-vacancy");
          }, 1000);
        });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
        footer: '<a href="">Why do I have this issue?</a>',
      });
    }
  };

  return (
    <>
      {isLoading ? (
        <span className="  text-xs font-medium text-blue-800 text-center p-0.5 leading-none rounded-full px-2 dark:bg-blue-900 dark:text-blue-200 absolute -translate-y-1/2 -translate-x-1/2 top-2/4 left-1/2">
          <div role="status">
            <svg
              aria-hidden="true"
              className="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
              viewBox="0 0 100 101"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                fill="currentColor"
              />
              <path
                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                fill="currentFill"
              />
            </svg>
          </div>
        </span>
      ) : (
        <>
          <div class="container mx-auto  mb-10">
            <h1 class="text-xl font-bold ">Edit Data</h1>
          </div>
          <div className="container mx-auto mt-10  mb-10">
            <small>Data Job</small>
            <hr className="mb-10" />
            <div className="mb-6">
              <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                Title
              </label>
              <input
                onChange={(e) => {
                  settitle(e.target.value);
                }}
                value={title}
                name="title"
                type="text"
                placeholder="Contoh value -> FrontendDeveloper"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                required
              />
            </div>
            <div className="mb-6">
              <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                Job Description
              </label>
              <textarea
                onChange={(e) => {
                  setjob_description(e.target.value);
                }}
                value={job_description}
                name="job_description"
                type="text"
                placeholder="Contoh value -> Melakukan implementasi tampilan web dll"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                required
              />
            </div>
            <div className="mb-6">
              <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                Job Qualification
              </label>
              <textarea
                onChange={(e) => {
                  setjob_qualification(e.target.value);
                }}
                value={job_qualification}
                name="job_qualification"
                type={"text"}
                placeholder="Contoh value -> Harus bisa React dll"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                required
              />
            </div>
            <div className="mb-6">
              <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                Job Type
              </label>
              <input
                onChange={(e) => {
                  setjob_type(e.target.value);
                }}
                value={job_type}
                name="job_type"
                type={"text"}
                placeholder="Contoh value -> onSite/work from home/hybir"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                required
              />
            </div>
            <div className="mb-6">
              <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                Job Ttenure
              </label>
              <input
                onChange={(e) => {
                  setjob_tenure(e.target.value);
                }}
                value={job_tenure}
                name="job_tenure"
                placeholder="Contoh value -> kontrak, magang dll"
                type={"text"}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                required
              />
            </div>

            <div className="mb-6">
              <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                Job Status
              </label>
              <input
                onChange={(e) => {
                  setjob_status(e.target.value);
                }}
                value={job_status}
                name="job_status"
                type={"number"}
                placeholder="Contoh value -> 0 dan 1. 0 untuk Ditutup, 1 untuk Dibuka"
                min={0}
                max={1}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                required
              />
            </div>
            <small>Data Company</small>
            <hr className="mb-10" />
            <div className="mb-6">
              <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                Company Name
              </label>
              <input
                onChange={(e) => {
                  setcompany_name(e.target.value);
                }}
                value={company_name}
                name="company_name"
                type={"text"}
                placeholder="Contoh value -> Google"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                required
              />
            </div>
            <div className="mb-6">
              <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                Company Image URL
              </label>
              <input
                onChange={(e) => {
                  setcompany_image_url(e.target.value);
                }}
                value={company_image_url}
                name="company_image_url"
                type={"text"}
                placeholder="Contoh value ->  Bisa cari di google atau www.istockphoto.com dengan keyword company logo, klik kanan pada gambar lalu copy image address"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                required
              />
            </div>
            <div className="mb-6">
              <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                Company City
              </label>
              <input
                onChange={(e) => {
                  setcompany_city(e.target.value);
                }}
                value={company_city}
                name="company_city"
                placeholder="Contoh value -> Jakarta"
                type="text"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                required
              />
            </div>
            <small>Data Salary</small>
            <hr className="mb-10" />

            <div className="mb-6">
              <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                Salary Min
              </label>
              <input
                onChange={(e) => {
                  setsalary_min(e.target.value);
                }}
                value={salary_min}
                name="salary_min"
                type="number"
                placeholder="Contoh value -> 9000000"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                required
              />
            </div>
            <div className="mb-6">
              <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300">
                Salary Max
              </label>
              <input
                onChange={(e) => {
                  setsalary_max(e.target.value);
                }}
                value={salary_max}
                name="salary_max"
                type="number"
                placeholder="Contoh value -> 10000000"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                required
              />
            </div>

            <button
              onClick={handleSubmit}
              className="w-full text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
            >
              Submit
            </button>
          </div>
        </>
      )}
    </>
  );
}
export default EditForm;
